import { css } from "@emotion/css";

export const fonts = {
  redFont: css`
    font-size: 20px;
    color: red;
  `,
};
